import { Link } from 'react-router';

/** 404 for the SPA catch-all route. */
export function NotFound(): React.JSX.Element {
  return (
    <main className="flex min-h-screen items-center justify-center px-6">
      <div className="text-center">
        <h1 className="text-2xl font-semibold tracking-tight">Page not found</h1>
        <p className="mt-2 text-slate-600">The page you are looking for does not exist.</p>
        <p className="mt-6">
          <Link to="/" className="font-medium text-slate-900 underline underline-offset-4">
            Go to the start
          </Link>
        </p>
      </div>
    </main>
  );
}
